<template>
    <div class="card mt-4">
        <div class="card-body">
            <div class="change-product-seller">
                <h5 class="">Change ownership request</h5>

                <p v-if="product_detail.metas && product_detail.metas.change_ownership_request">
                    <em
                        >Request has been sent to the new owner [<span class="text-primary">{{ product_detail.metas.change_ownership_request }}</span
                        >].
                    </em>
                </p>

                <input type="text" class="form-control" v-model="customer_email" placeholder="New owner email" />
                <button class="btn btn-primary rounded mt-3" @click.prevent="requestChangeOwnership()">
                    {{ product_detail.metas && product_detail.metas.change_ownership_request ? 'Change request' : 'Request' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';

export default {
    props: ['product_detail'],
    data() {
        return {
            customer_email: '',
            customerSuggestions: [
                {
                    data: []
                }
            ]
        };
    },
    methods: {
        async requestChangeOwnership() {
            if (!this.customer_email.trim()) {
                this.$toasted.global.error({
                    message: 'Please enter a customer email'
                });
                return;
            }

            const url = `${Env.baseUrl}/customer/reg-product/request-change-ownership`;
            this.spinner(true);

            try {
                const res = await AuthApis.postApi(url, {
                    customer_email: this.customer_email,
                    product_id: this.product_detail.id
                });

                this.spinner(false);
                this.$toasted.global.success({
                    message: res.data.message
                });
                if (res.status === 200) {
                    this.customer_email = ''; // Clear the input after success
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                }
            } catch (err) {
                this.spinner(false);
                console.error('Error assigning ownership:', err);

                let errorMessage = 'Failed to assign ownership';
                if (err.response) {
                    if (err.response.status === 404) {
                        errorMessage = 'API endpoint not found. Please check the URL configuration.';
                    } else if (err.response.data && err.response.data.message) {
                        errorMessage = err.response.data.message;
                    }
                }

                this.$toasted.global.error({
                    message: errorMessage
                });
            }
        }
    }
};
</script>
